import React, { FC } from 'react';
import SummaryCashMulti from '../../../../../presentational/prices/multiCurrency/cash/summaryCash/SummaryCashMulti';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../../store/selectors/currentDealSelectors';
import usePriceLoadingState from '../../../../../../react/usePriceLoadingState';

const MultiCurrencyCashContainer: FC<{ onIndicativeClick: () => void }> = ({ onIndicativeClick }) => {
  const primaryTotalPrice: IPrice = useSelector(currentDealSelectors.getPrimaryPriceTotal);
  const secondaryTotalPrice: IPrice = useSelector(currentDealSelectors.getSecondaryPriceTotal);
  const isDataLoading = usePriceLoadingState();

  return (
    <SummaryCashMulti
      primaryTotal={primaryTotalPrice}
      secondaryTotal={secondaryTotalPrice}
      isLoading={isDataLoading}
      onIndicativeClick={onIndicativeClick}
      indicativeLabel="vehicleTotalPrice"
    />
  );
};

export default MultiCurrencyCashContainer;
